import { useSelector} from "react-redux";
import SimpleText , { BlueLink } from "@/components/texts/simpleText";
import AjudaAccordions from "@/components/acorddions/ajudaAccordions";
import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "../../store/slices/offerSlice";

export default function Chat() {
    const offer_type = useSelector(GET_OFFER_TYPE)

    const events = new Events();
    return (
        <>
            <AjudaAccordions title={'Chat'} 
                LabelEvent="restaurar_senha_chat_abrir">
                <SimpleText>
                   <>Fale conosco on-line pelo <BlueLink target="_blank" href="https://chat.directtalk.com.br/static/?chatId=807f62e9-ded9-4ad4-b6a1-4fb7b6e4687e"
                    onClick={()=> {
                        events.trigger("restaurar_senha_chat_link_chat_estadao", { offer_type })
                    }}
                   >chat Estadão</BlueLink></>
                    <br/>
                    <br/>
                    De 2a a 6a feira, das <b>7h às 18h.</b> <br/>
                    Sábados, domingos e feriados, das <b>7h às 18h.</b>
                </SimpleText>

            </AjudaAccordions>
        </>
    )
}